/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParticipantClientUrlDto
 */
export interface ParticipantClientUrlDto {
    /**
     * URL for the client participant
     * @type {string}
     * @memberof ParticipantClientUrlDto
     */
    url?: string | null;
}

/**
 * Check if a given object implements the ParticipantClientUrlDto interface.
 */
export function instanceOfParticipantClientUrlDto(value: object): value is ParticipantClientUrlDto {
    return true;
}

export function ParticipantClientUrlDtoFromJSON(json: any): ParticipantClientUrlDto {
    return ParticipantClientUrlDtoFromJSONTyped(json, false);
}

export function ParticipantClientUrlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantClientUrlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ParticipantClientUrlDtoToJSON(json: any): ParticipantClientUrlDto {
    return ParticipantClientUrlDtoToJSONTyped(json, false);
}

export function ParticipantClientUrlDtoToJSONTyped(value?: ParticipantClientUrlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

